import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { getTokenInfo } from './../../../UseToken';
import { reqGET } from '../../../Utils';

import Loader from '../../Loader/Loader';

import { language } from './Language';

import {api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

export default function View(props) {

	const [lang, ] = useState('pt');

    const [dados, set_dados] = useState(data_interface);

    const [entries, set_entries] = useState([]);
    const [equipments, set_equipments] = useState([]);
    const [classes, set_classes] = useState([]);
    const [activities, set_activities] = useState([]);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

     // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(async res => {

                if(res.data !== undefined && res.data.length > 0) {
                    set_dados(res.data[0])

                    if(res.data[0].info.id_usado_para_gerar_pagamento !== undefined && res.data[0].info.id_usado_para_gerar_pagamento !== '') {

                        await reqGET(`${api_crud_base}/qr/history/payment/${res.data[0].info.id_usado_para_gerar_pagamento}`)
                        .then(res_2 => {

                            if(res_2.data !== undefined && res_2.data.length > 0) {

                                if(res_2.data[0].info !== undefined && res_2.data[0].info !== null) {
                                    if(res_2.data[0].info.classes !== undefined && res_2.data[0].info.classes !== null) {
                                        set_classes(res_2.data[0].info.classes)
                                    }
                                    if(res_2.data[0].info.entries !== undefined && res_2.data[0].info.entries !== null) {
                                        set_entries(res_2.data[0].info.entries)
                                    }
                                    if(res_2.data[0].info.equipments !== undefined && res_2.data[0].info.equipments !== null) {
                                        set_equipments(res_2.data[0].info.equipments)
                                    }
                                    if(res_2.data[0].info.experiencias !== undefined && res_2.data[0].info.experiencias !== null) {
                                        set_activities(res_2.data[0].info.experiencias)
                                    }
                                }

                            }

                        })
                        .catch(() => 404
                            //  TODO: ENVIAR PÃ�GINA 404
                            //  alert(error)); 
                        );

                    }

                }

            })
            .catch(() => 404
                //  TODO: ENVIAR PÃ�GINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))

        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);

    return (isRedirect ?
            <Redirect to={endpoints.list} replace />
        :
            isloading ?
                <Loader />
            :
                <main>
                    <div className={`dash-cards header`}>
                        <h2 className="dash-title">{language[lang].component}</h2>
                        <p>{language[lang].component}</p>
                    </div>

                    <div className={`dash-cards body`}>
                        <div className="container">
                            <div className="row">
            
                                <div className="mb-5 mb-xl-10">
                                    <div className='card'>

                                        <div id="div-content">

                                            <div className="card-body p-4">
                                                <div className='tab-content'>

                                                    <div className="tab-pane show active" role="tabpanel">
                                                        <div className='col-12'>
                                                            <div className="row">
                                                                <div className="col-12 col-sm-10 offset-sm-1 mt-3">
                                                                    <div className='row'>
                                                                        <div className='col-12'>
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_name}</label>
                                                                            {dados.info.documento.user_info.name}
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_vat}</label>
                                                                            {dados.info.documento.user_info.vat}
                                                                        </div>
                                                                        <div className="col-12">
                                                                            <label className="fs-6 required fw-bold mb-2 me-4" style={{width: '150px'}}>{language[lang].field_n_encomenda}</label>
                                                                            {dados.id}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className='col-12 col-sm-8 offset-sm-2 mb-6 p-5'>
                                                                    <table className="table table-striped">
                                                                        <thead>
                                                                            <tr>
                                                                                <td>Designação</td>
                                                                                <td align="right">Preço</td>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {
                                                                            dados.info.documento.linhas.map((el, k) => {
                                                                                return (
                                                                                    <tr key={k}>
                                                                                        <td>{el.designacao}</td>
                                                                                        <td align="right">{parseFloat(el.total_liquido).toFixed(2)} €</td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            }
                                                                        </tbody>
                                                                        <tfoot>
                                                                            <tr className='d-none'>
                                                                                <td align="right">Total Iliquido</td>
                                                                                <td align="right">{parseFloat(dados.info.documento.total_iliquido_documento).toFixed(2)} €</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td align="right">IVA</td>
                                                                                <td align="right">{parseFloat(dados.info.documento.total_iva_documento).toFixed(2)} €</td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td align="right">Total</td>
                                                                                <td align="right">{parseFloat(dados.info.documento.total_documento).toFixed(2)} €</td>
                                                                            </tr>
                                                                        </tfoot>
                                                                    </table>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                {
                                                                entries.length > 0 ?
                                                                    <div className='col-6 col-sm-4 mb-6 p-5'>
                                                                        <h3 className="fs-6 required fw-bold mb-2 me-4">Forfaits</h3>

                                                                        <table className="table table-striped">
                                                                            <thead>
                                                                                <tr>
                                                                                    <td>Acção</td>
                                                                                    <td align="right">Data</td>
                                                                                    <td align="right">Hora</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                entries.map((el, k) => {
                                                                                    return (
                                                                                        <tr key={k}>
                                                                                            <td>{el.status}</td>
                                                                                            <td align="right">{el.data.split('T')[0]}</td>
                                                                                            <td align="right">{el.data.split('T')[1].split('.')[0].replace('T', ' ')}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                :
                                                                    null
                                                                }

                                                                {
                                                                equipments.length > 0 ?
                                                                    <div className='col-6 col-sm-4 mb-6 p-5'>
                                                                        <h3 className="fs-6 required fw-bold mb-2 me-4">Equipamentos</h3>

                                                                        <table className="table table-striped">
                                                                            <thead>
                                                                                <tr>
                                                                                    <td>Acção</td>
                                                                                    <td align="right">Data</td>
                                                                                    <td align="right">Hora</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                equipments.map((el, k) => {
                                                                                    return (
                                                                                        <tr key={k}>
                                                                                            <td>{el.status}</td>
                                                                                            <td align="right">{el.data.split('T')[0]}</td>
                                                                                            <td align="right">{el.data.split('T')[1].split('.')[0].replace('T', ' ')}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                :
                                                                    null
                                                                }

                                                                {
                                                                classes.length > 0 ?
                                                                    <div className='col-6 col-sm-4 mb-6 p-5'>
                                                                        <h3 className="fs-6 required fw-bold mb-2 me-4">Aulas</h3>

                                                                        <table className="table table-striped">
                                                                            <thead>
                                                                                <tr>
                                                                                    <td>Acção</td>
                                                                                    <td align="right">Data</td>
                                                                                    <td align="right">Hora</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                classes.map((el, k) => {
                                                                                    return (
                                                                                        <tr key={k}>
                                                                                            <td>{el.status}</td>
                                                                                            <td align="right">{el.data.split('T')[0]}</td>
                                                                                            <td align="right">{el.data.split('T')[1].split('.')[0].replace('T', ' ')}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                :
                                                                    null
                                                                }

                                                                {
                                                                activities.length > 0 ?
                                                                    <div className='col-6 col-sm-4 mb-6 p-5'>
                                                                        <h3 className="fs-6 required fw-bold mb-2 me-4">Experiências</h3>

                                                                        <table className="table table-striped">
                                                                            <thead>
                                                                                <tr>
                                                                                    <td>Acção</td>
                                                                                    <td align="right">Data</td>
                                                                                    <td align="right">Hora</td>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {
                                                                                activities.map((el, k) => {
                                                                                    return (
                                                                                        <tr key={k}>
                                                                                            <td>{el.status}</td>
                                                                                            <td align="right">{el.data.split('T')[0]}</td>
                                                                                            <td align="right">{el.data.split('T')[1].split('.')[0].replace('T', ' ')}</td>
                                                                                        </tr>
                                                                                    )
                                                                                })
                                                                                }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                :
                                                                    null
                                                                }
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className={'dash-cards footer'}>
                        <nav className="navbar bottom-navbar navbar-light">
                            <div className="navbar-footer">
                                <ul className="navbar-nav float-left"></ul>
                                <ul className="navbar-nav float-right">
                                    <li className="nav-item">
                                        <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
                                            <img alt='' src={'./img/cancelar.svg'} />
                                            <span>{language[lang].cancel}</span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                </main>
    )
}